exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n@media (max-width: 1088px) {\n.empty-container[data-v-5a1c530b] {\n    min-height: 63px;\n    min-width: 36px;\n}\n}\n", "", {"version":3,"sources":["/home/runner/work/online-store/online-store/src/components/header/NavigationItems/EmptyItem.vue"],"names":[],"mappings":";AAAA;AACE;IACE,iBAAiB;IACjB,gBAAgB;CAAE;CAAE","file":"EmptyItem.vue","sourcesContent":["@media (max-width: 1088px) {\n  .empty-container {\n    min-height: 63px;\n    min-width: 36px; } }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a1c530b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header/NavigationItems/EmptyItem.vue
// module id = dFv1
// module chunks = 18